import React from "react";

export default function Marquee({ items }) {
  return (
    <div className="fsh-marquee">
      <div className="track">
        {[0, 1].map((k) => (
          <span key={k}>
            {items.map((t, i) => (
              <span key={i}>✦ {t}</span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
